import { AreaFragment } from "src/state/gql/_types"
import { FormSchema } from "src/utils/forms"

export type AgencyOperationsAdminVenueAreaCreateFragment = Omit<AreaFragment, 'id' | 'status' | 'created_at' | 'updated_at' | 'created_by_user' | 'updated_by_user' | 'area_status' | 'area_type'   >

export const AgencyOperationsAdminVenueAreaCreateSchema: FormSchema<AgencyOperationsAdminVenueAreaCreateFragment> = {
    id: "area",
    title: "Area",
    groups: {
        default: {
            label: 'Default' 
        }
    },
    fields: {
        type: {
            group: 'default',
            label: "Type",
            type: "area-type-select",
            grid: 12,
            validation: {
                required: {
                    value: true,
                    message: '{field} is required'
                }
            }
        },
        name: {
            group: 'default',
            label: "Name",
            type: "text",
            grid: 12,
            validation: {
                required: {
                    value: true,
                    message: '{field} is required'
                }
            }
        },
        description: {
            group: 'default',
            label: "Description",
            type: "textarea",
            grid: 12,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        poc: {
            group: 'default',
            label: "Poc",
            type: "textarea",
            grid: 12,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        website: {
            group: 'default',
            label: "Website",
            type: "text",
            grid: 12,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        instagram: {
            group: 'default',
            label: "Instagram",
            type: "text",
            grid: 12,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        }
    }
}

export type AgencyOperationsAdminVenueAreaUpdateFragment = Omit<AreaFragment, 'id' | 'tenant_id' | 'venue_id' |'created_at' | 'updated_at' | 'created_by_user' | 'updated_by_user' | 'area_status' | 'area_type' >

export const AgencyOperationsAdminVenueAreaUpdateSchema: FormSchema<AgencyOperationsAdminVenueAreaUpdateFragment> = {
    id: "area",
    title: "Area",
    groups: {
        default: {
            label: 'Default' 
        }
    },
    fields: {
        status: {
            group: 'default',
            label: "Status",
            type: "area-status-select",
            grid: 12,
            validation: {
                required: {
                    value: true,
                    message: '{field} is required'
                }
            }
        },
        type: {
            group: 'default',
            label: "Type",
            type: "area-type-select",
            grid: 12,
            validation: {
                required: {
                    value: true,
                    message: '{field} is required'
                }
            }
        },
        name: {
            group: 'default',
            label: "Name",
            type: "text",
            grid: 12,
            validation: {
                required: {
                    value: true,
                    message: '{field} is required'
                }
            }
        },
        description: {
            group: 'default',
            label: "Description",
            type: "textarea",
            grid: 12,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        poc: {
            group: 'default',
            label: "Poc",
            type: "textarea",
            grid: 12,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        website: {
            group: 'default',
            label: "Website",
            type: "text",
            grid: 12,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        instagram: {
            group: 'default',
            label: "Instagram",
            type: "text",
            grid: 12,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        }
    }
}